import React from 'react';
import {
  Button, ButtonToolbar, Input, InputGroup, Message, Stack,
} from 'rsuite';
import { CreatedPartner } from '../../../api/partner/partnerApiTypes';
import { showErrorMessage, showSuccessMessage } from '../../../utils/message';

interface Props {
  createdPartner: CreatedPartner;
  onDone: () => void;
}

export default function PartnerCreatedToken({ createdPartner, onDone }: Props): JSX.Element {
  async function copyToken() {
    try {
      await navigator.clipboard.writeText(createdPartner.apiToken);
      showSuccessMessage('Token copied to clipboard.');
    } catch (error) {
      showErrorMessage('Token could not be copied to the clipboard. Please copy it by hand.');
    }
  }

  return (
    <Stack direction="column" spacing={10} alignItems="stretch">
      <span>
        {`API token of the partner ${createdPartner.partnerName} (${createdPartner.code}) is`}
      </span>
      <InputGroup>
        <Input readOnly value={createdPartner.apiToken} />
        <InputGroup.Button appearance="primary" onClick={() => copyToken()}>
          Copy
        </InputGroup.Button>
      </InputGroup>
      <Message type="warning" showIcon>
        Copy the token now, as it cannot be retrieved later.
      </Message>
      <ButtonToolbar>
        <Button appearance="primary" onClick={() => onDone()}>
          Done
        </Button>
      </ButtonToolbar>
    </Stack>
  );
}
